import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from "@angular/router";
import { ConfigService } from "../core/services/config/config.service";

@Injectable({
    providedIn: 'root'
})
export class ProfileGuard implements CanActivate {

    paths: { url:string, fn:() => boolean }[] = []

    constructor(private router: Router, private configService: ConfigService) {
        this.paths.push({url:"/configens", fn:() => this.configService.config.hasEnsManagerProfile() || this.configService.config.hasServiceManagerProfile()})
        this.paths.push({url:"/cross", fn:() => this.configService.config.hasEnsManagerProfile() || this.configService.config.hasManagerApps()})
        this.paths.push({url:"/home/catproc/public-procedure", fn:() => this.configService.config.hasUserProfile()})  
        this.paths.push({url:"/home/catproc/public-catalog", fn: () => this.configService.config.hasUserProfile()})
        this.paths.push({url:"/aocadmin", fn: () => this.configService.config.hasAocManagerProfile()})
        this.paths.push({url:"/eacadmin", fn: () => this.configService.config.hasAdminProfile()})
        this.paths.push({url:"/home/catproc/public-batch", fn: () => this.configService.config.hasBatchProfile()})
        this.paths.push({url:"/home/catproc/public-support", fn: () => this.configService.config.hasSupportProfile()})
    }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        let candidates = this.paths.filter(p => state.url.startsWith(p.url))
        if (candidates.length == 0){
            return true
        }

        let check = candidates[0].fn
        
        let res = check()

        if (res == false){
            this.router.navigate(['/home/catproc/public-home']); 
        }

        return res
    }

}